/* eslint-disable no-restricted-globals */
import { isBrowser } from '@cap/ssr-common-utils';
import { isIOS, isAndroid, isMeiTuan, isDianPing, isWechat, isWXMiniProgram } from '@cap/utils';

// 容器 UA 行为文档: https://km.sankuai.com/page/53371192
const UAParser = require('ua-parser-js');

export const isMobile = (userAgent?: string) => {
  userAgent = userAgent ?? navigator.userAgent;
  const { device } = UAParser(userAgent);
  return device.type === 'mobile' || device.type === 'tablet';
};

/**
 * 判断是否为小程序环境
 */
export { isWXMiniProgram };

// 灵犀appnm匹配规则
export const getAppnm = async (ua?: string) => {
  ua = ua ?? navigator.userAgent.toLowerCase();
  let appnm = '';
  // eslint-disable-next-line no-shadow
  if (/meituangroup\/\d+\./i.test(ua)) {
    appnm = 'group';
  }
  if (/meituanwaimai-c\/\d+\./i.test(ua)) {
    appnm = 'waimai';
  }
  if (/moviepro/i.test(ua)) {
    appnm = 'moviepro';
  }
  if (/maoyan/i.test(ua)) {
    appnm = 'movie';
  }
  if (/dp\/com\.dianping\.[\w.]+\/([\d.]+)/i.test(ua)) {
    appnm = 'dianping_nova';
  }
  if (isWechat(ua)) {
    appnm = 'weixin';
  }

  if (await isWXMiniProgram(ua)) {
    appnm = 'weixinmini';
  }

  return appnm;
};

export const getDeviceType = (userAgent?: string) => {
  userAgent = userAgent ?? navigator.userAgent;
  if (isIOS(userAgent)) return 'iOS';
  if (isAndroid(userAgent)) return 'Android';
  return 'unknown';
};

export const isMeituanOrDianping = () => {
  const meituan = isMeiTuan(navigator.userAgent);
  const dianping = isDianPing(navigator.userAgent);
  return meituan || dianping;
};

export const getPlatform = () => {
  if (isBrowser) {
    const { userAgent: ua } = navigator;
    const host = location.host.toLowerCase();
    if (host.indexOf('ping') !== -1 || ua.indexOf('com.dianping') !== -1) {
      return 'dianping';
    }
    if (host.indexOf('ecube') !== -1) {
      return 'business';
    }
    if (host.indexOf('icube') !== -1) {
      return 'staff';
    }
  }
  return 'meituan';
};
